import React, { useState, useEffect } from 'react';

const DashBordmenu = ({ title, status, onClick }) => {
    return (
        <div style={{ display: window.innerWidth < 576 ? 'block' : 'none', padding: '0px, 20px' }}>
            <div className="d-flex justify-content-between align-items-center mb-0 mt-0 pl-3 pr-3" >
                <h3 className="mb-0">{title}</h3>
                <a className="navbar-toggler" href="#" onClick={onClick} style={{ backgroundColor: 'var(--themecolor)' }}>
                    {status === false ? <i className="lnr lnr-menu" style={{ color: 'white' }}></i> : <i className="lnr lnr-cross" style={{ color: 'white' }}></i>}
                </a>
            </div>
        </div>

    );
};

export default DashBordmenu;
